import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SERVICING_ACTION_TYPE } from '../actions';

const initialState = {
  payments: [],
  paymentSchedule: [],
  summary: null,
  escrowDisbursements: [],
  interactions: [],
  drawRequests: [],
};

const servicingReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case SERVICING_ACTION_TYPE.GET_PAYMENTS:
        draft.payments = payload ?? [];
        break;

      case SERVICING_ACTION_TYPE.GET_PAYMENT_SCHEDULE:
        draft.paymentSchedule = payload ?? [];
        break;

      case SERVICING_ACTION_TYPE.GET_SUMMARY:
        draft.summary = payload ?? null;
        break;

      case SERVICING_ACTION_TYPE.GET_ESCROW_DISBURSEMENTS:
        draft.escrowDisbursements = payload ?? [];
        break;

      case SERVICING_ACTION_TYPE.GET_INTERACTIONS:
        draft.interactions = payload ?? [];
        break;

      case SERVICING_ACTION_TYPE.GET_DRAW_REQUESTS:
        draft.drawRequests = payload ?? [];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default servicingReducer;
